module.exports = __webpack_public_path__ + "static/media/photo14.4d4819c2.jpg";